import React, { useState } from 'react';
import { t } from 'i18next';
import {
  Button,
  ModalOverlayWithoutClose,
  Paragraph,
  Collapsible,
  Link,
} from '@sentara-health/optimahealth_web';
import { useMyDelete } from '@sentara-health/sentara-api-hooks-core';
import { DeleteAccountPopup } from 'templates';
import { useAdobeAnalytics } from '@sentara-health/platform-analytics';
import {
  errorhandler,
  useDeviceType,
  DeviceTypes,
  NavigateConst,
  domainForSegment,
  ANALYTICS_MESSAGES,
} from 'common';

const DeleteProfile = ({
  expand = true,
  onExpand = () => {},
  onCollapse = () => {},
}: {
  expand?: boolean;
  onExpand?: () => void;
  onCollapse?: () => void;
}) => {
  const { MyDeleteType } = useMyDelete();
  const LINK_BTN_BLOCK_MOB = 'btn-links darkblue-color ps-0 mb-2';
  const [isSuccessPopup, setIsSuccessPopup] = useState<boolean>(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isShowContent, setIsShowContent] = useState<boolean>(false);
  const deviceType = useDeviceType();
  const { contentListingItemClicked } = useAdobeAnalytics();
  const isMobile = deviceType === DeviceTypes.MOBILE;
  // Function to handle account deletion
  const deleteAccount = async () => {
    setIsShowContent(false);
    setIsConfirmOpen(true);
  };

  function closeModal() {
    setIsOpen(false);
  }

  // Function to open the delete account modal
  const submitDelete = (e: any) => {
    setIsOpen(true);
    setIsShowContent(true);
    setIsConfirmOpen(false);
  };

  function closePopUpModal() {
    setIsSuccessPopup(false);
    localStorage.clear();
    window.location.href = NavigateConst.signIn;
  }

  const confirmDeleteAccount = async () => {
    const response = await MyDeleteType();
    if (response.errorCode) {
      errorhandler(response?.errorCode);
    } else {
      contentListingItemClicked({
        segment: `${domainForSegment}/profile`,
        contentListing: {
          eventType: 'Content Listing Item Clicked',
          listing: {
            content: [
              {
                contentId: '623',
                contentTitle: ANALYTICS_MESSAGES.DELETE_USER,
                itemPosition: 29,
              },
            ],
          },
        },
      });
      setIsOpen(false);
      setIsConfirmOpen(false);
      setIsSuccessPopup(true);
    }
  };
  return (
    <Collapsible
      title={t('profile.deleteAccount')}
      id={'deleteAccount'}
      isMobile={isMobile}
      key={`${t('profile.deleteAccount')}-${isMobile ? 'mobile' : 'desktop'}`}
      expand={expand}
      onExpand={onExpand}
      onCollapse={onCollapse}
      className="mb-3 pb-2"
    >
      <div className="set_my_preferences">
        <div className="border_wrapper">
          <div className="user_address_wrapper">
            {/* Render confirmation message and button to delete account */}
            <Paragraph
              text={
                <>
                  {t('profile.confirmationDeleteAccountInfo')}{' '}
                  <Link
                    to={NavigateConst.footerContactUs}
                    data-testid="customerSupportLink"
                    className="gold-link text-decoration-underline"
                  >
                    {t('profile.customerSupportLink')}
                  </Link>
                </>
              }
              variant="regular"
              data-testid="confirmationDeleteAccountInfo"
              className="pb-3 mb-2"
            />
            <Button
              dataTestId={'deleteAccountButton'}
              variant={LINK_BTN_BLOCK_MOB}
              onClick={(e: any) => {
                e.preventDefault();
                submitDelete(e);
              }}
            >
              {t('profile.continueToDeleteAccount')}
            </Button>
            {/* Render the DeleteAccountPopup component */}
            <DeleteAccountPopup
              isOpen={isOpen}
              closeModal={closeModal}
              isShowContent={isShowContent}
              variant="primary_btn"
              deleteAccount={deleteAccount}
              isConfirmOpen={isConfirmOpen}
              confirmDeleteAccount={confirmDeleteAccount}
            />
            <ModalOverlayWithoutClose
              isOpen={isSuccessPopup}
              overlayInfo="Modal information"
            >
              <div
                data-testid="accountDeleteSuccessModal"
                className="d-flex flex-column align-items-center"
              >
                <h5
                  data-testid="loggedMessage"
                  className="label_logged_message"
                >
                  {t('profile.accountDeleteSuccessMsg1')}
                </h5>
                <br />
                <Button
                  dataTestId="okButton"
                  variant="primary_btn"
                  onClick={closePopUpModal}
                >
                  {t('common.ok')}
                </Button>
              </div>
            </ModalOverlayWithoutClose>
            {/* Delete account end */}
          </div>
        </div>
      </div>
    </Collapsible>
  );
};

export default DeleteProfile;
